import { FC } from 'react'
import { createPortal } from 'react-dom'

interface ConferenceLoadingOverlayProps {
  visible: boolean
}

export const ConferenceLoadingOverlay: FC<ConferenceLoadingOverlayProps> = ({ visible }) => {
  if (!visible || typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <div
      className='position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center'
      style={{
        zIndex: 2000,
        backgroundColor: 'rgba(255, 255, 255, 0.82)',
        backdropFilter: 'blur(3px)',
      }}
    >
      <div
        className='bg-white rounded shadow d-flex flex-column align-items-center justify-content-center'
        style={{
          minWidth: '320px',
          minHeight: '180px',
          padding: '24px 32px',
          border: '1px solid rgba(0, 0, 0, 0.08)',
        }}
      >
        <div
          className='spinner-border text-primary mb-4'
          role='status'
          style={{ width: '3rem', height: '3rem' }}
        >
          <span className='sr-only'>Processando a pesquisa...</span>
        </div>
        <div className='text-center'>
          <div className='fw-bold' style={{ color: '#181c32', fontSize: '1rem' }}>
            Processando a pesquisa...
          </div>
          <div className='text-muted mt-2' style={{ fontSize: '0.9rem' }}>
            Aguarde enquanto os pedidos são consultados.
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}